import React from "react";

// import { Container } from './styles';

function UploadFiles() {
  return <div>Upload</div>;
}

export default UploadFiles;
